import React from "react";
import { Award, Building2, HeartPulse, FileCheck2 } from "lucide-react";
import { FACTS } from "./hcaData";
import { HcaReveal } from "./HcaReveal";

const TRUST = [
    [Award, "PTIB approved", "Private Training Institution Branch, BC"],
    [FileCheck2, "BC provincial curriculum", "Recognized by the BC Care Aide Registry"],
    [HeartPulse, "BLS-CPR & FoodSafe", "Certifications included"],
    [Building2, "Surrey campus", "On-site, instructor-led classes"],
];

export const HcaFacts = () => (
    <section data-testid="hca-facts-section" className="bg-white border-b border-[#D8DEE6]">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 lg:grid-cols-4 divide-x divide-[#D8DEE6]">
            {FACTS.map((f, i) => (
                <HcaReveal key={f.label} delay={i * 0.08} className="py-8 px-4 lg:px-8">
                    <div className="flex items-baseline gap-1.5" data-testid={`hca-fact-${i}`}>
                        <span className="font-display text-4xl lg:text-5xl text-[#0E1E3A]">{f.k}</span>
                        <span className="text-sm font-semibold text-[#D4A140] uppercase">{f.u}</span>
                    </div>
                    <p className="text-sm text-[#5E6B7E] mt-1">{f.label}</p>
                </HcaReveal>
            ))}
        </div>
        <div className="bg-[#F9F8F6] border-t border-[#D8DEE6]" data-testid="hca-accreditation-bar">
            <div className="max-w-7xl mx-auto px-6 py-6 grid grid-cols-2 lg:grid-cols-4 gap-6">
                {TRUST.map(([Icon, t, s]) => (
                    <div key={t} className="flex items-start gap-3">
                        <Icon className="h-5 w-5 text-[#2E6F40] mt-0.5 shrink-0" />
                        <div>
                            <p className="text-sm font-semibold text-[#0E1E3A]">{t}</p>
                            <p className="text-xs text-[#5E6B7E]">{s}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);
